import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styles from "../../characteristic.module.scss";
import { CharacteristicCustomForm } from "../../characteristicCustomForm";
import { CharacteristicHistory } from "../../characteristicHistory";
import { CharacteristicTissue } from "../../characteristicTissue";
import { CharacteristicTouch } from "../../characteristicTouch";
import { CharacteristicClassification } from "../../characteristicClassification";
import { useParams } from "react-router-dom";
import { CharacteristicProgress } from "../CharacteristicProgress";
import { useReadOnly } from "../../../../../hooks/useReadOnly";
import { usePermissions } from "../../../../../hooks/usePermissions";

export const useTabList = ({ assessmentDetails, overrideToggle, setShowWound, updateCharStatus, getCharDetails }) => {
  const { patientId, assessmentId } = useParams();
  const isReadOnly = useReadOnly();
  const { hasPermission } = usePermissions();
  const characteristicTabsData = useSelector((state) => state.patient.characteristicTabs);
  const ne1getWounAssessmentDetailData = useSelector((state) => state.patient.ne1getWounAssessmentDetail);

  const [tabListNew, setTabListNew] = useState([]);

  useEffect(() => {
    if (!characteristicTabsData?.length) return;

    const finalTabNew = characteristicTabsData.map((data) => {
      const sharedProps = {
        styles,
        patientId,
        assessmentId,
        assessmentDetails,
        getCharDetails,
        overrideToggle,
        isCompleted: data?.isCompleted,
        characteristicTabsData,
        isReadOnly,
        hasPermission,
      };

      const base = {
        completed: data.isCompleted,
        name: data.category === "Tissue Type" ? "Tissue Types" : data.category,
        key: data.category === "Tissue Type" ? "tissueTypes" : data.category,
      };

      if (data?.id === 0) {
        switch (data.category) {
          case "History/Cause":
            return {
              ...base,
              key: "historyCause",
              content: <CharacteristicHistory {...sharedProps} setShowWound={false} />,
            };

          case "Tissue Type":
            return {
              ...base,
              content: <CharacteristicTissue {...sharedProps} />,
            };

          case "Touch & View Details":
            return {
              ...base,
              key: "touchAndView",
              content: <CharacteristicTouch {...sharedProps} setShowWound={setShowWound} updateCharStatus={updateCharStatus} />,
            };

          case "Classification":
            return {
              ...base,
              key: "classification",
              content: <CharacteristicClassification {...sharedProps} setShowWound={setShowWound} />,
            };

          case "Set Progress":
            return {
              ...base,
              key: "setProgress",
              content: <CharacteristicProgress {...sharedProps} />,
            };

          default:
            return undefined;
        }
      }

      return {
        ...base,
        content: (
          <CharacteristicCustomForm
            name={data.category}
            formId={data.id}
            queryParam={{ ne1Id: patientId, assessmentId }}
            assessmentDetails={assessmentDetails}
            isCompleted={data?.isCompleted}
            characteristicTabsData={characteristicTabsData}
            isReadOnly={isReadOnly}
            hasPermission={hasPermission}
          />
        ),
      };
    });

    if (finalTabNew) {
      setTabListNew(finalTabNew);
    }
  }, [ne1getWounAssessmentDetailData, characteristicTabsData, assessmentDetails]); // eslint-disable-line react-hooks/exhaustive-deps

  return tabListNew;
};
